const dayAfter = (date) => new Date(Date.parse(`${date}T12:00:00Z`) + 86400000).toISOString().slice(0, 10);
const what = { balloon: "tu vuelo en globo", tour: "tu tour", school: "tu visita escolar" };
/** "5:30 a. m." from "05:30:00". */
function clock(time) {
    const [h, m] = time.split(":").map(Number);
    if (!Number.isFinite(h) || !Number.isFinite(m))
        return "";
    return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${h < 12 ? "a. m." : "p. m."}`;
}
/** "mañana, jueves 29 de octubre," / "hoy," / "el viernes 30 de octubre," for the visit day. */
function when(date, today) {
    const day = new Intl.DateTimeFormat("es-MX", { weekday: "long", day: "numeric", month: "long", timeZone: "UTC" }).format(new Date(`${date}T12:00:00Z`)).replace(",", "");
    if (date === today)
        return "hoy";
    if (date === dayAfter(today))
        return `mañana, ${day},`;
    return `el ${day},`;
}
/**
 * The WhatsApp reminder that goes with the balance link: the visit day, what is left to pay and the
 * link. The same text the team sends from the case and the worker sends on the day the balance is due.
 */
export function balanceMessage(input, today) {
    const first = input.name.trim().split(/\s+/)[0] ?? "";
    const percent = input.total > 0 ? Math.round((input.balance / input.total) * 100) : 0;
    const hour = input.time ? clock(input.time) : "";
    const amount = new Intl.NumberFormat("es-MX", { style: "currency", currency: input.currency || "MXN" }).format(input.balance);
    return [
        `Hola${first ? ` ${first}` : ""} 👋`,
        `Te recordamos que ${what[input.service] ?? "tu experiencia"} es ${when(input.date, today)}${hour ? ` a las ${hour}` : ""}`.replace(/,$/, "") + ".",
        `Para completar tu reserva falta ${percent === 50 ? "el 50% restante" : "el saldo"}: ${amount}.`,
        `Puedes pagarlo aquí con tarjeta:\n${input.url}`,
        "¡Te esperamos!",
    ].join("\n\n");
}
